<template>
  <div class="container-fluid p-0">
    <div class="container-fluid">
      <!-- fixed-content -->
      <div class="row w-100 align-items-center">
        <!-- Left Tabs -->
        <div class="col-4 tabs-container text-center">
          <Tabs :items="itemTabs" :active="activeTab" />
        </div>

        <!-- Right Filters (flex-end) -->
        <div class="col-8 d-flex justify-content-end" style="z-index: 8">
          <div class="dropdown me-2">
            <button class="btn dropdown-toggle" id="timeOptions" type="button" data-bs-toggle="dropdown"
              aria-expanded="false">
              {{ timeSelected === "" ? "Select Time" : timeSelected }}
            </button>
            <div class="dropdown-menu dropdown-menu-end" aria-labelledby="timeOptions">
              <a v-for="option in timeOptions" :key="option" class="dropdown-item"
                :class="{ active: option === timeSelected }" @click="timeSelected = option" href="javascript:void(0)">{{
                  option }}</a>
            </div>
          </div>

          <div class="dropdown">
            <button class="btn dropdown-toggle" id="clusterOptions" type="button" data-bs-toggle="dropdown"
              aria-expanded="false">
              {{ clusterSelected ? clusterSelected.label : "Select Cluster" }}
            </button>
            <div class="dropdown-menu dropdown-menu-end" aria-labelledby="clusterOptions">
              <button v-for="option in clusterOptions" :key="option.value" class="dropdown-item"
                :class="{ active: option.value === clusterSelected?.value }" @click="clusterSelected = option"
                type="button">
                {{ option.label }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 p-0">
          <div class="large-card position-relative custom-scrollbar">
            <div class="row g-4">
              <div class="col-12">
                <EasyDataTable v-model:server-options="serverOptions" :items="items"
                  :server-items-length="serverItemsLength" :loading="loading" :headers="Headers" :rows-items="rowItems"
                  hide-footer table-class-name="customize-table" rows-per-page-message="" theme-color="#0492FF">
                  <template #item-no="{ no }">
                    <div class="number">
                      {{ no }}
                    </div>
                  </template>
                  <template #item-Brightness="data">
                    <div v-if="formEdit.key !== data.key">
                      {{ data.Brightness }}
                    </div>
                    <div v-else class="input-number-custom d-flex">
                      <span role="button" @click="
                        () =>
                          (items[data.key].Brightness = data.Brightness - 10)
                      ">-</span>
                      <input class="form-control digits" type="number" :value="data.Brightness" />
                      <span role="button" @click="
                        () =>
                          (items[data.key].Brightness = data.Brightness + 10)
                      ">+</span>
                    </div>
                  </template>
                  <template #item-Status="data">
                    <div v-if="formEdit.key !== data.key">
                      {{ data.Status }}
                    </div>
                    <div v-else class="dropdown" style="width: 80px">
                      <button class="btn dropdown-toggle" id="statusOptions" type="button" data-bs-toggle="dropdown"
                        aria-expanded="false" style="width: 100%">
                        {{
                          items[data.key].Status === ""
                            ? "Select status"
                            : items[data.key].Status
                        }}
                      </button>
                      <div class="dropdown-menu dropdown-menu-end" aria-labelledby="statusOptions">
                        <a v-for="option in statusOptions" :key="option" class="dropdown-item" :class="option === items[data.key].Status ? ' active' : ''
                          " @click="() => (items[data.key].Status = option)" href="javascript:void(0)">{{ option }}</a>
                      </div>
                    </div>
                  </template>
                  <template #item-edit="data">
                    <div>
                      <button class="btn-save" role="button" @click="() => save(data)" v-if="formEdit.key === data.key">
                        <svg xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33" fill="none">
                          <ellipse cx="16.3178" cy="16.5" rx="16.3178" ry="16.5" fill="#A3E2FF" />
                          <path
                            d="M25.3789 11V23C25.3789 23.55 25.1832 24.021 24.7919 24.413C24.4006 24.805 23.9296 25.0007 23.3789 25H9.37891C8.82891 25 8.35824 24.8043 7.96691 24.413C7.57557 24.0217 7.37957 23.5507 7.37891 23V9C7.37891 8.45 7.57491 7.97933 7.96691 7.588C8.35891 7.19667 8.82957 7.00067 9.37891 7H21.3789L25.3789 11ZM16.3789 22C17.2122 22 17.9206 21.7083 18.5039 21.125C19.0872 20.5417 19.3789 19.8333 19.3789 19C19.3789 18.1667 19.0872 17.4583 18.5039 16.875C17.9206 16.2917 17.2122 16 16.3789 16C15.5456 16 14.8372 16.2917 14.2539 16.875C13.6706 17.4583 13.3789 18.1667 13.3789 19C13.3789 19.8333 13.6706 20.5417 14.2539 21.125C14.8372 21.7083 15.5456 22 16.3789 22ZM10.3789 14H19.3789V10H10.3789V14Z"
                            fill="#0492FF" />
                        </svg>
                      </button>
                      <button class="btn-cancel" role="button" @click="() => canceli(data.key)"
                        v-if="formEdit.key === data.key">
                        <svg xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33" fill="none">
                          <ellipse cx="16.5" cy="16.5" rx="16.5" ry="16.5" fill="#FFD6D6" />
                          <path d="M21.5 11.5L11.5 21.5M11.5 11.5L21.5 21.5" stroke="#FF4C4C" stroke-width="2"
                            stroke-linecap="round" />
                        </svg>
                      </button>
                      <button :disabled="isEdit" @click="() => edit(data)" class="btn-edit" role="button" v-else>
                        <svg xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33" fill="none">
                          <ellipse cx="16.3178" cy="16.5" rx="16.3178" ry="16.5"
                            :fill="isEdit == false ? '#BCEFDB' : '#D3D3D3'" />
                          <path
                            d="M7.37891 21.4624V24.5024C7.37891 24.7824 7.59891 25.0024 7.87891 25.0024H10.9189C11.0489 25.0024 11.1789 24.9524 11.2689 24.8524L22.1889 13.9424L18.4389 10.1924L7.52891 21.1024C7.42891 21.2024 7.37891 21.3224 7.37891 21.4624ZM25.0889 11.0424C25.1816 10.9499 25.2552 10.84 25.3053 10.7191C25.3555 10.5981 25.3813 10.4684 25.3813 10.3374C25.3813 10.2065 25.3555 10.0768 25.3053 9.95582C25.2552 9.83485 25.1816 9.72496 25.0889 9.63244L22.7489 7.29244C22.6564 7.19974 22.5465 7.12619 22.4255 7.07601C22.3046 7.02583 22.1749 7 22.0439 7C21.9129 7 21.7833 7.02583 21.6623 7.07601C21.5413 7.12619 21.4314 7.19974 21.3389 7.29244L19.5089 9.12244L23.2589 12.8724L25.0889 11.0424Z"
                            :fill="isEdit == false ? '#218863' : '#707070	'" />
                        </svg>
                      </button>
                    </div>
                  </template>
                </EasyDataTable>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div
        class="modal fade"
        id="successModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="successModal"
        data-bs-backdrop="static"
        aria-hidden="true"
      >
        <SuccessModal
          :btnText="'Done'"
          :message="successMessage"
          :onSave="successSave"
        />
      </div> -->
      <!-- @cancel="handleCancel" -->
      <my-modal :visible="modal.showModal" :title="modal.title" :titledescription="modal.description"
        :message="modal.message" :type="modal.type" :showNote="false" :showConfirm="true" :showCancel="false"
        @confirm="handleConfirm" :confirmMessageButton="modal.confirmMessageButton">
        <template #icon>
          <!-- <img
            src="/success-icon.png"
            alt="Success Icon"
            style="width: 140px; height: 140px"
          />-->
        </template>
      </my-modal>
    </div>
  </div>
</template>
<script>
import { Modal } from "bootstrap";

// import { mockServerItems } from "../data/scheduler/timeTable";
import Tabs from "../components/tabs/index.vue";
import checkIcon from "@/assets/images/right.png";
import seruIcon from "@/assets/images/seru.png";
// import SuccessModal from "./uikits/modal/SuccessModal.vue";

export default {
  data() {
    return {
      modal: {
        showModal: false,
        title: "SUCCESS !",
        description: "",
        message: "",
        type: "success", //warning,
        confirmMessageButton: "Yes",
      },
      showModal: false,
      activeTab: "scheduler-time",
      Headers: [
        {
          text: "No.",
          value: "no",
          sortable: false,
          width: 150,
        },
        {
          text: "Hour",
          value: "Hour",
          sortable: false,
        },
        {
          text: "Minute",
          value: "Minute",
          sortable: false,
        },
        {
          text: "Status",
          value: "Status",
          sortable: false,
          width: 200,
        },
        {
          text: "Brightness",
          value: "Brightness",
          sortable: false,
          width: 250,
        },
        {
          text: "Edit",
          value: "edit",
          sortable: false,
          width: 200,
        },
      ],
      itemTabs: [
        {
          id: "scheduler-tab-1",
          value: "scheduler-time",
          label: "Scheduler Time",
        },
        {
          id: "scheduler-tab-2",
          value: "set-holidays",
          label: "Set Holidays",
        },
      ],
      rowItems: [5, 10, 50, 100],
      items: [],
      serverItemsLength: 0,
      serverOptions: {
        page: 1,
        rowsPerPage: 14,
      },
      loading: false,
      formEdit: {},
      isEdit: false,
      statusOptions: ["On", "Off"],
      timeOptions: ["Weekday", "Weekend", "Holiday"],
      clusterOptions: [
        {
          label: "Cluster A",
          value: "a",
        },
        {
          label: "Cluster B",
          value: "b",
        },
        {
          label: "Cluster C",
          value: "c",
        },
      ],
      timeSelected: "Weekday",
      clusterSelected: "",
      userType: "",
      options: [
        "Enforcement",
        "Traffic Teams",
        "Management",
        "Data Science",
        "Guest",
        "IT Team",
      ],
      temp: [],
      // successModal: null,
      // successMessage: "",
      // successSave: () => {},
    };
  },
  components: {
    Tabs,
    // SuccessModal,
  },
  computed: {
    // restApiUrl() {
    //   const { page, rowsPerPage, sortBy, sortType } = this.serverOptions;
    //   // console.log(sortBy);
    //   // console.log(sortType);
    //   if (sortBy && sortType) {
    //     return `http://localhost:8080/api?page=${page}&limit=${rowsPerPage}&sortBy=${sortBy}&sortType=${sortType}`;
    //   } else {
    //     return `http://localhost:8080/api?page=${page}&limit=${rowsPerPage}`;
    //   }
    // },
  },
  watch: {
    serverOptions() {
      // this.loadFromServer();
    },
    clusterSelected() {
      this.getData();
    },
    timeSelected() {
      this.getData();
    },
    // temp: {
    //   handler(newVal, oldVal) {
    //     console.log("Array content changed");
    //     console.log("newval", newVal);
    //     console.log("oldValue", oldVal);
    //   },
    //   deep: true,
    // },
  },
  mounted() {
    this.setHeaderComponent();
    this.getListOfCluster();
    // this.successModal = new Modal(document.getElementById("successModal"), {});

    // this.getData();
    // this.loadFromServer();
  },
  methods: {
    canceli(data) {
      this.items[parseInt(data)].Brightness =
        this.items[parseInt(data)].TempBrightness;

      this.items[parseInt(data)].Status = this.items[parseInt(data)].TempStatus;

      this.formEdit = {};
      this.isEdit = false;
    },
    handleConfirm() {
      this.modal.showModal = false;
    },
    getListOfCluster() {
      this.clusterOptions = [];

      this.$http.get(":11005/api/v1/cluster").then((res) => {
        if (!res.error) {
          let response = res.message;
          // console.log(response);

          for (var i = 0; i < response.length; i++) {
            let obj = {
              label: response[i].ClusterName,
              value: response[i].ClusterID,
            };

            this.clusterOptions.push(obj);
          }

          this.clusterSelected = this.clusterOptions[0];
        }
      });
    },
    getData() {
      console.log("memanggil");
      this.$http
        .get(
          ":11000/api/v1/scheduler/" +
          this.clusterSelected.value +
          "/" +
          this.timeSelected.toLowerCase()
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            this.temp = [];
            this.items = [];
            for (var i = 0; i < response.length; i++) {
              let obj = {
                key: `${i}`,
                no: `${i}`,
                Hour: response[i].Hour,
                Minute: response[i].Minute,
                Status: response[i].Status == 1 ? "On" : "Off",
                TempStatus: response[i].Status == 1 ? "On" : "Off",
                Brightness: response[i].Brightness,
                TempBrightness: response[i].Brightness,
              };

              this.items.push(obj);
              this.temp.push(obj);
            }
          }
        });
    },
    // async loadFromServer() {
    //   this.hidePaginationIndex();
    //   this.loading = true;
    //   const { serverCurrentPageItems, serverTotalItemsLength } =
    //     await mockServerItems(this.serverOptions);
    //   this.items = serverCurrentPageItems;
    //   this.serverItemsLength = serverTotalItemsLength;

    //   this.hidePaginationIndex();
    //   this.loading = false;
    // },
    hidePaginationIndex() {
      const paginationIndex = document.querySelector(
        ".pagination__items-index"
      );
      const paginationRowInput = document.querySelector(".rows-input");
      if (!paginationIndex || !paginationRowInput) return;
      setTimeout(() => {
        paginationIndex.innerHTML = "";
        paginationRowInput.innerHTML = "View";
      }, 0);
    },
    edit(data) {
      this.formEdit = data;
      this.isEdit = true;
    },
    save(data) {
      this.formEdit = {};
      this.isEdit = true;

      let payload = [];

      // 1 - weekdays
      // 2 - weekend
      // 3 - holiday

      let timekind =
        this.timeSelected.toUpperCase() == "WEEKDAY"
          ? 1
          : this.timeSelected.toUpperCase() == "WEEKEND"
            ? 2
            : 3;


      for (var i = 0; i < this.items.length; i++) {
        let obj = {
          ScheduleProfile: timekind,
          ScheduleIndex: parseInt(this.items[i].no),
          ScheduleHour: parseInt(this.items[i].Hour),
          ScheduleMinute: parseInt(this.items[i].Minute),
          Status: this.items[i].Status.toUpperCase() == "ON" ? 1 : 0,
          Brightness: this.items[i].Brightness / 10,
        };

        payload.push(obj);
      }


      this.$http
        .post(":11004/api/v1/schedule/" + this.clusterSelected.value, payload)
        .then((res) => {
          if (!res.error) {
            let response = res.message;

            this.$swal({
              title: `<div class="success-title"><img src="${checkIcon}" alt="check" /><p class="header">SUCCESSFUL!</p></div><p class="success-text">${response}</p>`,

              confirmButtonText: "Done",

              customClass: {
                title: "swal2-content",
                popup: "success-popup swal2-content",
                confirmButton: "success-button",
              },
              buttonsStyling: false,
            });

            this.getData();
            this.isEdit = false;
            // this.successMessage = res.message;

            // this.successSave = () => this.successModal.hide();
            // this.successModal.show();
          }
        })
        .catch((error) => {
          const message =
            error?.response?.data?.message ||
            "Something went wrong. Please try again.";

          this.$swal({
            title: `<div class="warning-title"><img src="${seruIcon}" alt="check" /><p class="header">WARNING!</p></div>`,
            html: `<p class="warning-subtitle">Note</p><p class="warning-subtitle2">${message}</p>`,
            // showCancelButton: true,
            confirmButtonText: "OK",
            // cancelButtonText: "No",
            customClass: {
              title: "swal2-content",
              popup: "warning-popup swal2-content",
              confirmButton: "warning-button",
              // cancelButton: "warning-cancel-button",
            },
            buttonsStyling: false,
          }).then((result) => {
            this.isEdit = false;
          });
        });
    },
    formatNumber(value) {
      return Intl.NumberFormat().format(value);
    },
    getAlphabet(index) {
      const alpha = Array.from(Array(26)).map((e, i) => i + 65);
      const alphabet = alpha.map((x) => String.fromCharCode(x));
      return alphabet[index];
    },
    setHeaderComponent() {
      this.$store.dispatch("common/setHeaderComponent", {
        title: "Scheduler",
        subtitle: "",
        showBack: false,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-edit {
  display: flex;
  border: none;
  background: transparent;
  // border-radius: 50%;
}

.btn-save {
  display: flex;
  border: none;
  background: transparent;
  // border-radius: 50%;
}

.btn-cancel {
  display: flex;
  border: none;
  background: transparent;
  // border-radius: 50%;
}

.input-number-custom {
  width: 128px;
  height: 31px;
  flex-shrink: 0;
  border-radius: 5px;
  border: 1px solid #eee;
  background: #fff;
  justify-content: space-between;
  align-items: center;
  padding: 0 8px;

  input {
    width: 40px;
    height: 20px;
    color: #000;
    text-align: center;
    font-family: Inter;
    font-size: 13px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    border-radius: 3px;
    border: 1px solid #eee;
    background: #fff;
    padding: 0;
  }

  span {
    width: 31px;
    height: 31px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
}

.tabs-container {
  max-width: max-content;
}

.fixed-content {
  position: fixed;
  top: 114px;
  left: 112px;
  height: 51px;
  width: auto;
  z-index: 8;
}

.dropdown .dropdown-toggle {
  position: relative;
  width: 215px;
  padding: 0 15px;
  border-radius: 8px;
  border: none;
  background: #fff !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 44px;
  color: #9b9a9a !important;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;

  &:hover {
    border: 1px solid #218863;
  }

  &::after {
    color: #218863;
    right: 15px;
  }
}

.large-card {
  height: calc(100vh - 63px - 167px);
  width: calc(100% + 22px);
  margin-top: 63px;
  margin-bottom: 23px;
  padding: 17px 0;
  padding-right: 10px;
  padding-top: 0;
  overflow-y: auto;
  overflow-x: hidden;
  background: #f5f6fa;
}

.small-card {
  height: 99px;

  img {
    width: 50px;
    height: 50px;
  }

  h2 {
    color: #000;
    font-family: Inter;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    display: flex;
    margin-bottom: 6px;
  }

  h3 {
    color: #ababab;
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    /* 125% */
    margin-bottom: 3px;
  }
}

:deep(.customize-table) {
  --easy-table-tbody-row: #ffffff;
}

.form-group i {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 22px;
  width: 24px;
  height: 24px;
  font-size: 24px;
  font-weight: bold;
  color: #a3a3a3;
}

.btn-search {
  display: flex;
  width: 215px;
  height: 44px;
  padding: 8px 13px 8px 45px;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  border: none;
  border-radius: 5px;
  background: #fff;
  color: #a3a3a3;
  font-family: Poppins;
  font-size: 16px;
  font-weight: 400;
  line-height: normal;

  &::placeholder {
    color: #d8d8d8;
    font-style: italic;
  }

  &:focus {
    outline: none;
  }
}
</style>
